import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import './Checkbox.scss';
import FastEqualComponent from '../../FastEqualComponent/FastEqualComponent';
import { coalesce } from '../../../utils/utils';
require('animate.css/animate.min.css');

export class Checkbox extends FastEqualComponent {
  render() {
    const {
      ariaLabel,
      checked,
      disabled,
      e2eSuffix = 'el',
      id,
      inline,
      labelText,
      onChange = noop,
      onClick = noop,
      required,
      input = {},
    } = this.props;
    const inlineStyleName = inline ? 'checkbox-inline' : '';
    return (
      <label
        className={`checkbox ${inlineStyleName} e2e-checkbox-label-${e2eSuffix} college-branded-checkbox`}
      >
        {labelText}
        <input
          type="checkbox"
          aria-label={coalesce(ariaLabel, labelText)}
          id={id}
          className={`e2e-checkbox-input-${e2eSuffix}`}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
          onClick={(event) => onClick(event.target.checked)}
          checked={!!checked && !disabled}
          required={required}
          tabIndex="0"
          {...input}
        />
        <span
          className={`checkbox-checkmark ${inlineStyleName} e2e-checkbox-checkmark-${e2eSuffix} college-branded-checkmark`}
        >
          <svg
            viewBox="0 2 24 24"
            className={`checkbox-icon ${inlineStyleName}`}
            xmlns="https://www.w3.org/2000/svg"
          >
            <polygon
              clipRule="evenodd"
              fillRule="evenodd"
              fill="#ffffff"
              points="20.5,2 9.5,16.5 3,10 0,13 10,23 24,5"
            />
          </svg>
        </span>
      </label>
    );
  }
}

Checkbox.propTypes = {
  id: PropTypes.string,
  e2eSuffix: PropTypes.string,
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  required: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
